import 'svelte/internal/disclose-version';

StudyRoot[$.FILENAME] = 'src/client/StudyRoot.svelte';

import * as $ from 'svelte/internal/client';
import { untrack } from "svelte";
import Study from "../ui/Study.svelte";
import { noRouter } from "./route.ts";
import { StudyController } from "./study.svelte.ts";

var root = $.add_locations(
	$.from_html(
		`

<!>`,
		1
	),
	StudyRoot[$.FILENAME],
	[]
);

export default function StudyRoot($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, StudyRoot);

	let router = $.prop($$props, 'router', 3, noRouter);
	const study = $.tag($.derived(() => new StudyController($$props.source, undefined, undefined, router())), 'study');

	$.user_effect(() => {
		const s = $.get(study);

		untrack(() => s.open());

		return () => s.dispose();
	});

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root();
	var node = $.sibling($.first_child(fragment));

	$.add_svelte_meta(
		() => Study(node, {
			get study() {
				return $.get(study);
			}
		}),
		'component',
		StudyRoot,
		19,
		0,
		{ componentTag: 'Study' }
	);

	$.append($$anchor, fragment);

	return $.pop($$exports);
}